/* tslint:disable */
/* eslint-disable */
/**
 * Sports App Training Plans
 * API for the Sports App Training Plans
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CreateHistoryEntry,
  TrainingHistory,
  UpdateHistoryEntry,
} from '../models/index';
import {
    CreateHistoryEntryFromJSON,
    CreateHistoryEntryToJSON,
    TrainingHistoryFromJSON,
    TrainingHistoryToJSON,
    UpdateHistoryEntryFromJSON,
    UpdateHistoryEntryToJSON,
} from '../models/index';

export interface TrainingHistoryCreateRequest {
    createHistoryEntry: CreateHistoryEntry;
}

export interface TrainingHistoryDeleteEntryRequest {
    entryId: string;
}

export interface TrainingHistoryGetHistoryByUserRequest {
    userId: string;
}

export interface TrainingHistoryUpdateRequest {
    updateHistoryEntry: UpdateHistoryEntry;
}

/**
 * 
 */
export class TrainingHistoryApi extends runtime.BaseAPI {

    /**
     */
    async trainingHistoryCreateRaw(requestParameters: TrainingHistoryCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['createHistoryEntry'] == null) {
            throw new runtime.RequiredError(
                'createHistoryEntry',
                'Required parameter "createHistoryEntry" was null or undefined when calling trainingHistoryCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/training-history`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateHistoryEntryToJSON(requestParameters['createHistoryEntry']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async trainingHistoryCreate(requestParameters: TrainingHistoryCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.trainingHistoryCreateRaw(requestParameters, initOverrides);
    }

    /**
     */
    async trainingHistoryDeleteEntryRaw(requestParameters: TrainingHistoryDeleteEntryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['entryId'] == null) {
            throw new runtime.RequiredError(
                'entryId',
                'Required parameter "entryId" was null or undefined when calling trainingHistoryDeleteEntry().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/training-history/{entryId}`.replace(`{${"entryId"}}`, encodeURIComponent(String(requestParameters['entryId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async trainingHistoryDeleteEntry(requestParameters: TrainingHistoryDeleteEntryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.trainingHistoryDeleteEntryRaw(requestParameters, initOverrides);
    }

    /**
     */
    async trainingHistoryGetHistoryRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TrainingHistory>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/training-history`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TrainingHistoryFromJSON(jsonValue));
    }

    /**
     */
    async trainingHistoryGetHistory(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TrainingHistory> {
        const response = await this.trainingHistoryGetHistoryRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async trainingHistoryGetHistoryByUserRaw(requestParameters: TrainingHistoryGetHistoryByUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TrainingHistory>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling trainingHistoryGetHistoryByUser().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/training-history/{userId}`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters['userId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TrainingHistoryFromJSON(jsonValue));
    }

    /**
     */
    async trainingHistoryGetHistoryByUser(requestParameters: TrainingHistoryGetHistoryByUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TrainingHistory> {
        const response = await this.trainingHistoryGetHistoryByUserRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async trainingHistoryUpdateRaw(requestParameters: TrainingHistoryUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TrainingHistory>> {
        if (requestParameters['updateHistoryEntry'] == null) {
            throw new runtime.RequiredError(
                'updateHistoryEntry',
                'Required parameter "updateHistoryEntry" was null or undefined when calling trainingHistoryUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/training-history`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateHistoryEntryToJSON(requestParameters['updateHistoryEntry']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TrainingHistoryFromJSON(jsonValue));
    }

    /**
     */
    async trainingHistoryUpdate(requestParameters: TrainingHistoryUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TrainingHistory> {
        const response = await this.trainingHistoryUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
